import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    connect() {
        if (this.element.tagName === "DIALOG") {
            this.element.showModal();
        }
    }

    close() {
        if (this.element.tagName === "DIALOG") {
            this.element.close();
        } else {
            this.element.remove();
        }
        // If loaded via Turbo Frame, refreshing the frame might be needed or just closing is enough.
        // For debugging, we just close.
    }

    closeBackground(event) {
        if (event.target === this.element) {
            this.close();
        }
    }
}